import { render, staticRenderFns } from "./CrudConfig.vue?vue&type=template&id=223fb188&"
import script from "./CrudConfig.vue?vue&type=script&lang=js&"
export * from "./CrudConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports